import setupChoice from './choice';

export default function setupSearchPage() {
  setupChoice();

  const isAuthorPath = () => window.location.pathname.includes('/author');
  const searchPath = () => (isAuthorPath() ? '/search/author' : '/search');

  // Search forms
  document.querySelectorAll('form[action="/search"]').forEach((form) => {
    form.addEventListener('submit', handleSearchSubmit);
  });

  // Clear filters
  document.querySelectorAll('.js-clear-filters').forEach((button) => {
    button.addEventListener('click', handleClearFilters);
  });

  ///
  /// Search tab functionality
  ///

  const tabContainer = document.querySelector('.search-tabs');
  if (tabContainer) {
    const contentTab = tabContainer.querySelector('[data-tab="content"]');
    const authorTab = tabContainer.querySelector('[data-tab="author"]');
    const contentPanel = tabContainer.querySelector('.content-panel');
    const authorsPanel = tabContainer.querySelector('.authors-panel');

    if (contentTab && authorTab && contentPanel && authorsPanel) {
      contentTab.addEventListener('click', () => switchTab('content'));
      authorTab.addEventListener('click', () => switchTab('author'));

      if (isAuthorPath()) {
        switchTab('author');
      }
    }
  }

  function switchTab(tabName) {
    const contentTab = tabContainer.querySelector('[data-tab="content"]');
    const authorTab = tabContainer.querySelector('[data-tab="author"]');
    const contentPanel = tabContainer.querySelector('.content-panel');
    const authorsPanel = tabContainer.querySelector('.authors-panel');

    const isAuthorTabActive = tabName === 'author';

    contentTab.classList.toggle('is-active', !isAuthorTabActive);
    authorTab.classList.toggle('is-active', isAuthorTabActive);

    contentPanel.style.display = isAuthorTabActive ? 'none' : 'block';
    authorsPanel.style.display = isAuthorTabActive ? 'block' : 'none';

    const path = isAuthorTabActive ? '/search/author' : '/search';
    history.replaceState(null, '', `${path}${window.location.search}`);
  }

  ///
  /// Sort dropdown: toggled by tap/click (hover does not exist on touch screens)
  ///

  const sortDropdown = document.querySelector('.dropdown');
  const sortButton = sortDropdown && sortDropdown.querySelector('.sort-button');

  if (sortButton) {
    const setSortOpen = (open) => {
      sortDropdown.classList.toggle('is-open', open);
      sortButton.setAttribute('aria-expanded', String(open));
    };

    sortButton.addEventListener('click', (e) => {
      e.stopPropagation();
      setSortOpen(!sortDropdown.classList.contains('is-open'));
    });

    document.addEventListener('click', (e) => {
      if (!sortDropdown.contains(e.target)) setSortOpen(false);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setSortOpen(false);
    });
  }

  ///
  /// Sorting: keeps the filters and the active tab, restarts from the first page
  ///

  document.querySelectorAll('.sort-option').forEach((option) => {
    option.addEventListener('click', (e) => {
      e.preventDefault();
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('sort', option.getAttribute('data-sort'));
      searchParams.delete('page');
      window.location.href = `${searchPath()}?${searchParams.toString()}`;
    });
  });

  ///
  /// Form submit: drop blank params, keep the sort (relevance by default when searching)
  ///

  function handleSearchSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const searchParams = new URLSearchParams();

    for (const [key, value] of new FormData(form).entries()) {
      if (typeof value === 'string' && value.trim() !== '') {
        searchParams.append(key, value.trim());
      }
    }

    if (searchParams.has('search')) {
      const currentSort = new URLSearchParams(window.location.search).get('sort');
      searchParams.set('sort', currentSort === 'newest' ? 'newest' : 'relevance');
    }

    const query = searchParams.toString();
    window.location.href = `${searchPath()}${query ? `?${query}` : ''}`;
  }

  ///
  /// Clear filters: keep the search text only
  ///

  function handleClearFilters() {
    const text = (new URLSearchParams(window.location.search).get('search') || '').trim();

    const cleared = new URLSearchParams();
    if (text) {
      cleared.set('search', text);
    }

    const query = cleared.toString();
    window.location.href = `${searchPath()}${query ? `?${query}` : ''}`;
  }

  ///
  /// LOAD MORE: automatically when the end of the results gets close, the button stays as a fallback
  ///

  let postsCurrentPage = parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;
  let loading = false;
  let observer = null;

  const loadMoreContainer = document.querySelector('.load-more-container');
  if (loadMoreContainer) {
    loadMoreContainer.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('load-more-posts-btn')) {
        if (loading) return;
        loadMorePosts(e.target);
      }
    });

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        if (loading || !entries.some((entry) => entry.isIntersecting)) return;

        const button = loadMoreContainer.querySelector('.load-more-posts-btn');
        if (button && !button.disabled) loadMorePosts(button);
      }, { rootMargin: '0px 0px 400px 0px' });

      observer.observe(loadMoreContainer);
    }
  }

  function loadMorePosts(button) {
    loading = true;
    button.textContent = 'جاري التحميل...';
    button.disabled = true;

    const nextPage = postsCurrentPage + 1;
    const url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);

    fetch(url, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((data) => {
        postsCurrentPage = nextPage;

        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = data.posts;

        const container = button.closest('.load-more-container');
        tempContainer.querySelectorAll('.search_widget').forEach((post) => {
          container.insertAdjacentElement('beforebegin', post);
        });

        if (postsCurrentPage >= data.total_pages) {
          container.remove();
          if (observer) observer.disconnect();
        } else {
          button.textContent = 'تحميل المزيد من المواد';
          button.disabled = false;
          // re-observe so the check runs again if the end of the list is still in view
          if (observer) {
            observer.unobserve(container);
            observer.observe(container);
          }
        }

        loading = false;
      })
      .catch((error) => {
        console.error('Error loading more posts:', error);
        button.textContent = 'حدث خطأ، حاول مرة أخرى';
        button.disabled = false;
        loading = false;
        // no automatic retries after a failure, the button stays for a manual retry
        if (observer) observer.disconnect();
      });
  }
}
